import { Injectable } from '@angular/core';
import { ConfigService, CommunicationConfigService } from '@argalis-apps/angular-global';
import { Observable, of } from 'rxjs';
import { MSelector, MUser } from '@argalis-apps/models';
import { HttpClient } from '@angular/common/http';
import * as TEST from './data-test';

@Injectable({
  providedIn: 'root'
})
export class UtilisateurService {
  constructor(
    private configService: ConfigService,
    private communicationConfigService: CommunicationConfigService,
    private http: HttpClient
  ) {}

  getListResponsableAdministratif(): Observable<MUser.IClient[]> {
    if (this.configService.getOptions().useTestData === true) {
      return of(TEST.TEST_IResponsable_Administratif);
    } else {
      return this.http.get<MUser.IClient[]>(
        `${this.communicationConfigService.getApiUri()}/utilisateur/responsableAdministratif-selector`
      );
    }
  }

  getInfoCalendar() {
    return this.http.get(`${this.communicationConfigService.getApiUri()}/utilisateur/infoCalendar`);
  }
}
